export interface InvitationAccessInput {
  expiresAtMs: number;
  redeemedBy?: string | null;
  viewerUid?: string | null;
  nowMs?: number;
}

/**
 * Invitations remain usable until they expire. Once an invitation has been
 * redeemed, only that authenticated user may reopen it to finish a partially
 * completed onboarding flow.
 */
export const canAccessInvitation = ({
  expiresAtMs,
  redeemedBy,
  viewerUid,
  nowMs = Date.now(),
}: InvitationAccessInput): boolean => {
  if (expiresAtMs > nowMs) {
    return true;
  }

  return Boolean(viewerUid && redeemedBy && viewerUid === redeemedBy);
};
